export default __webpack_public_path__ + "static/media/available.27a5a861.png";